import type { Invoice } from '@/types/invoice'

const STORAGE_KEY = 'letfaktura:pendingInvoice'

export function savePendingInvoice(invoice: Invoice) {
    try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(invoice))
    } catch (e) {
        console.error('Could not store pending invoice', e)
    }
}

export function hasPendingInvoice(): boolean {
    try {
        return !!localStorage.getItem(STORAGE_KEY)
    } catch {
        return false
    }
}

export function takePendingInvoice(): Invoice | null {
    try {
        const raw = localStorage.getItem(STORAGE_KEY)
        if (!raw) return null
        localStorage.removeItem(STORAGE_KEY)
        return JSON.parse(raw) as Invoice
    } catch (e) {
        console.error('Could not read pending invoice', e)
        return null
    }
}

export function clearPendingInvoice() {
    try {
        localStorage.removeItem(STORAGE_KEY)
    } catch {
        // ignore
    }
}
